module.exports = __webpack_public_path__ + "img/shiba-head-level3.9218c300.png";